/** The file was automatically generated. Please do not modify manually */
import fr from './online.json';
export var strings_fr = fr;
